import type { Lang } from "@noli/core";

export enum Gallery_Words {
  "Search-for-an-image" = "Search-for-an-image",
  "Sort-by-Default" = "Sort-by-Default",
  "Sort-by-Likes" = "Sort-by-Likes",
  "Sort-by-Time" = "Sort-by-Time",
  "Copy-Prompt" = "Copy-Prompt",
  "Copy-all-Parameters" = "Copy-all-Parameters",
  "The-prompt-is-not-disclosed" = "The-prompt-is-not-disclosed",
  "The-image-is-not-generated-by-AI" = "The-image-is-not-generated-by-AI",
  "isTxt2Img" = "isTxt2Img",
  "isWenxin" = "isWenxin",
  "isImg2Img" = "isImg2Img",
  "isCircular" = "isCircular",
  "isAnime" = "isAnime",
  "isSuperResolution" = "isSuperResolution",
  "isInpainting" = "isInpainting",
  "isLandscapeSynthesis" = "isLandscapeSynthesis",
  "isAnimeSuperResolution" = "isAnimeSuperResolution",
  "isOutpainting" = "isOutpainting",
  "isScopeReplace" = "isScopeReplace",
  "Copied-to-the-clipboard" = "Copied-to-the-clipboard",
  "handle" = "handle",
  "End-of-the-Page" = "End-of-the-Page",
  "Follow" = "Follow",
  "Followed" = "Followed",
  "AllAuthors" = "AllAuthors",
  "Concerned" = "Concerned",
  "Sensitive" = "Sensitive",
  "Editing-Works" = "Editing-Works",
  "Enter-The-Reason-For-Reporting" = "Enter-The-Reason-For-Reporting",
  "Delete-Work" = "Delete-Work",
  "EditingWorks" = "EditingWorks",
  "Report" = "Report",
  "Republish" = "Republish",
  "sureDelete" = "sureDelete",
  "Cancel" = "Cancel",
  "Delete" = "Delete",
  "SureReport" = "SureReport",
  "SelectReason" = "SelectReason",
  "OtherReportingReasons" = "OtherReportingReasons",
  "EnterReason" = "EnterReason",
  "ConfirmTheReport" = "ConfirmTheReport",
  "SuccessfullyDeleted" = "SuccessfullyDeleted",
  "Report-submitted-successfully" = "Report-submitted-successfully",
  "SubmittedPublishing" = "SubmittedPublishing",
  "copy" = "copy",
  "showOriginal" = "showOriginal",
  "prompt" = "prompt",
  "negativePrompt" = "negativePrompt",
  "modelType" = "modelType",
  "originalImage" = "originalImage",
  "configStyle" = "configStyle",
  "styleText" = "styleText",
  "noliboxModelTag" = "noliboxModelTag",
  "animeModelTag" = "animeModelTag",
  "dreamlikeModelTag" = "dreamlikeModelTag",
  "deliberate-generalModelTag" = "deliberate-generalModelTag",
  "epicrealisim-realModelTag" = "epicrealisim-realModelTag",
  "revanime-3d-animeModelTag" = "revanime-3d-animeModelTag",
  // "animeModelTag" = "anime",
  // "dreamlikeModelTag" = "dreamlike",
}

export const galleryLangRecords: Record<Lang, Record<Gallery_Words, string>> = {
  zh: {
    [Gallery_Words["Search-for-an-image"]]: "请输入搜索词",
    [Gallery_Words["Sort-by-Default"]]: "默认排序",
    [Gallery_Words["Sort-by-Likes"]]: "最多点赞",
    [Gallery_Words["Sort-by-Time"]]: "最近发布",
    [Gallery_Words["Copy-Prompt"]]: "复制Prompt",
    [Gallery_Words["Copy-all-Parameters"]]: "复制参数",
    [Gallery_Words["The-prompt-is-not-disclosed"]]: "本图片未公开Prompt",
    [Gallery_Words["The-image-is-not-generated-by-AI"]]: "本图片非 AI 生成图",
    [Gallery_Words["isTxt2Img"]]: "文字生成图片",
    [Gallery_Words["isWenxin"]]: "文字生成图片",
    [Gallery_Words["isImg2Img"]]: "垫图生成",
    [Gallery_Words["isCircular"]]: "循环图样生成",
    [Gallery_Words["isAnime"]]: "动漫图片生成",
    [Gallery_Words["isSuperResolution"]]: "超分辨率",
    [Gallery_Words["isInpainting"]]: "图像修补",
    [Gallery_Words["isScopeReplace"]]: "局部替换",
    [Gallery_Words["isLandscapeSynthesis"]]: "合成风景",
    [Gallery_Words["isAnimeSuperResolution"]]: "动漫超分辨率",
    [Gallery_Words["isOutpainting"]]: "图片外延",
    [Gallery_Words["Copied-to-the-clipboard"]]: "已复制到剪切板",
    [Gallery_Words["handle"]]: "处理：",
    [Gallery_Words["End-of-the-Page"]]: "已经到底啦~",
    [Gallery_Words["Follow"]]: "关注",
    [Gallery_Words["Followed"]]: "已关注",
    [Gallery_Words["AllAuthors"]]: "全部作者",
    [Gallery_Words["Concerned"]]: "我关注的",
    [Gallery_Words["Sensitive"]]: "当前搜索词内含有敏感词，请重新输入",
    [Gallery_Words["Editing-Works"]]: "编辑作品",
    [Gallery_Words["Enter-The-Reason-For-Reporting"]]: "请输入举报理由",
    [Gallery_Words["Delete-Work"]]: "删除作品",
    [Gallery_Words["EditingWorks"]]: "编辑作品",
    [Gallery_Words["Report"]]: "举报",
    [Gallery_Words["Republish"]]: "再次发布",
    [Gallery_Words["sureDelete"]]: "作品删除后将不可恢复😳您确定要删除吗？",
    [Gallery_Words["Cancel"]]: "取消",
    [Gallery_Words["Delete"]]: "狠心删除",
    [Gallery_Words["SureReport"]]: "确认举报该作品？请输入举报理由",
    [Gallery_Words["SelectReason"]]: "选择举报理由",
    [Gallery_Words["OtherReportingReasons"]]: "其他举报理由或举报留言（非必填）",
    [Gallery_Words["EnterReason"]]: "请输入举报理由",
    [Gallery_Words["ConfirmTheReport"]]: "确认举报",
    [Gallery_Words["SuccessfullyDeleted"]]: "删除作品成功",
    [Gallery_Words["Report-submitted-successfully"]]: "举报提交成功",
    [Gallery_Words["SubmittedPublishing"]]: "已提交发布，请等待审核😁",
    [Gallery_Words["copy"]]: "复制",
    [Gallery_Words["showOriginal"]]: "查看原始输入",
    [Gallery_Words["prompt"]]: "指令 Prompt",
    [Gallery_Words["negativePrompt"]]: "负指令 Negative Prompt",
    [Gallery_Words["modelType"]]: "模型：",
    [Gallery_Words["originalImage"]]: "原图",
    [Gallery_Words["configStyle"]]: "配置",
    [Gallery_Words["styleText"]]: "风格: $",
    [Gallery_Words["noliboxModelTag"]]: "画宇宙模型",
    // [Gallery_Words.animeModelTag]: "动漫模型",
    // [Gallery_Words.dreamlikeModelTag]: "画宇宙2.0模型",
    [Gallery_Words["deliberate-generalModelTag"]]: "通用大模型",
    [Gallery_Words["epicrealisim-realModelTag"]]: "写实模型",
    [Gallery_Words["animeModelTag"]]: "二次元模型",
    [Gallery_Words["revanime-3d-animeModelTag"]]: "3D动漫模型",
    [Gallery_Words["dreamlikeModelTag"]]: "艺术模型",
  },
  en: {
    [Gallery_Words["Search-for-an-image"]]: "Search for an image",
    [Gallery_Words["Sort-by-Default"]]: "Sort by Default",
    [Gallery_Words["Sort-by-Likes"]]: " Sort by Likes",
    [Gallery_Words["Sort-by-Time"]]: "Sort by Time",
    [Gallery_Words["Copy-Prompt"]]: "Copy Prompt",
    [Gallery_Words["Copy-all-Parameters"]]: "Copy all Parameters",
    [Gallery_Words["The-prompt-is-not-disclosed"]]: "The prompt is not disclosed",
    [Gallery_Words["The-image-is-not-generated-by-AI"]]: "The image is not generated by AI",
    [Gallery_Words["isTxt2Img"]]: "Text to Image",
    [Gallery_Words["isWenxin"]]: "Text to Image",
    [Gallery_Words["isImg2Img"]]: "Image to Image",
    [Gallery_Words["isCircular"]]: "Circular Image",
    [Gallery_Words["isAnime"]]: "Anime Image",
    [Gallery_Words["isSuperResolution"]]: "Super Resolution",
    [Gallery_Words["isInpainting"]]: "inpainting - Inpainting",
    [Gallery_Words["isScopeReplace"]]: "Scope Replace",
    [Gallery_Words["isLandscapeSynthesis"]]: "Landscape Synthesis",
    [Gallery_Words["isAnimeSuperResolution"]]: "Anime Super Resolution",
    [Gallery_Words["isOutpainting"]]: "outpainting - Outpainting",
    [Gallery_Words["Copied-to-the-clipboard"]]: "Copied to the clipboard!",
    [Gallery_Words["handle"]]: "handle：",
    [Gallery_Words["End-of-the-Page"]]: "End of the Page ~",
    [Gallery_Words["Follow"]]: "Follow",
    [Gallery_Words["Followed"]]: "Followed",
    [Gallery_Words["AllAuthors"]]: "All Authors",
    [Gallery_Words["Concerned"]]: "Concerned",
    [Gallery_Words["Sensitive"]]: "The current search term contains sensitive words, re-enter",
    [Gallery_Words["Editing-Works"]]: "Editing Works",
    [Gallery_Words["Enter-The-Reason-For-Reporting"]]: "Enter The Reason For Reporting",
    [Gallery_Words["Delete-Work"]]: "Delete",
    [Gallery_Words["EditingWorks"]]: "Edit",
    [Gallery_Words["Report"]]: "Report",
    [Gallery_Words["Republish"]]: "Republish",
    [Gallery_Words["sureDelete"]]:
      "The work cannot be restored after deletion 😳 Are you sure you want to delete?",
    [Gallery_Words["Cancel"]]: "Cancel",
    [Gallery_Words["Delete"]]: "Delete",
    [Gallery_Words["SureReport"]]:
      "Are you sure to report this work? Please enter the reason for reporting",
    [Gallery_Words["SelectReason"]]: "Select the reason for reporting",
    [Gallery_Words["OtherReportingReasons"]]: "Other reporting reasons or messages (NotRequired)",
    [Gallery_Words["EnterReason"]]: "Enter the reason for reporting",
    [Gallery_Words["ConfirmTheReport"]]: "Confirm",
    [Gallery_Words["SuccessfullyDeleted"]]: "Successfully deleted the work",
    [Gallery_Words["Report-submitted-successfully"]]: "Report submitted successfully",
    [Gallery_Words["SubmittedPublishing"]]: "Submitted for publishing, please wait for approval 😁",
    [Gallery_Words["copy"]]: "Copy",
    [Gallery_Words["showOriginal"]]: "Show Original Prompt",
    [Gallery_Words["prompt"]]: "Prompt",
    [Gallery_Words["negativePrompt"]]: "Negative Prompt",
    [Gallery_Words["modelType"]]: "Model: ",
    [Gallery_Words["originalImage"]]: "Original Image",
    [Gallery_Words["configStyle"]]: "Config",
    [Gallery_Words["styleText"]]: "Style: $",
    [Gallery_Words["noliboxModelTag"]]: "Nolibox Model",
    // [Gallery_Words.animeModelTag]: "Anime Model",
    // [Gallery_Words.dreamlikeModelTag]: "Nolibox 2.0 Model",
    [Gallery_Words["deliberate-generalModelTag"]]: "General",
    [Gallery_Words["epicrealisim-realModelTag"]]: "Real",
    [Gallery_Words["animeModelTag"]]: "Anime",
    [Gallery_Words["revanime-3d-animeModelTag"]]: "3D Anime",
    [Gallery_Words["dreamlikeModelTag"]]: "DreamLike Art",
  },
};
